import PropTypes from 'prop-types'

const MenuActionItem = ({ show = true, ...restProps }) => (
  show ? <li><div {...restProps} /></li> : null
)

MenuActionItem.propTypes = {
  show: PropTypes.bool
}

export default MenuActionItem
